const SCHEME_NORMAL = 'normal';
const SCHEME_EXPAND = 'expand';

export { SCHEME_NORMAL, SCHEME_EXPAND };

// Commit trace: 2025-09-06T16:57:10 - docs: add inline comments to Menu.constants.js
